import Table from 'Components/SimpleTable';
import { isBoolean, isObject, sortBy } from 'lodash';
import React from 'react';
import { unixToDate } from 'utils/date';
import { getMetadataName } from 'utils/getMetadata.js';

const generateColumns = readings => {
    const properties = [
        { label: 'Name', dataKey: 'name' },
        { label: 'Activate Measurement?', dataKey: 'activate_measurement', transform: model => model.activate_measurement ? 'Yes' : 'No' },
        { label: 'Create Indicator?', dataKey: 'create_indicator', transform: model => model.create_indicator ? 'Yes' : 'No' }
    ];

    const dataKeys = new Set();
    readings.forEach(reading => {
        for (const dataKey of Object.keys(reading.extra)) {
            if (dataKeys.has(dataKey)) {
                continue;
            }

            const label = getMetadataName(dataKey);
            properties.push({ label, dataKey });
            dataKeys.add(dataKey);
        }
    });

    properties.push(
        { label: 'Usage Count', dataKey: 'measurements_count' },
        { label: 'Update', dataKey: 'updated_at', transform: model => `${model.updater_name} @ ${unixToDate(model.updated_at)}` }
    );

    return properties;
};

const Readings = props => {
    const { onRowClick, readings } = props;

    const columns = generateColumns(readings);

    let rows = readings.map(reading => {
        const object = { ...reading };

        Object.entries(reading.extra).forEach(([key, value]) => {
            if (isObject(value)) {
                value = JSON.stringify(value);
            }

            if (isBoolean(value)) {
                value = value ? 'Yes' : 'No';
            }

            object[getMetadataName(key)] = value;
            object[key] = value;
        });

        return object;
    });

    rows = sortBy(rows, 'modbus_memory_address', 'mbus_port_id');

    return (
        <Table columns={columns} onRowClick={onRowClick} rows={rows} rowsPerPage={100}/>
    );
};

export default Readings;
